import React from "react";

const badgeClass = (status) => {
  const s = (status || "").toLowerCase();
  if (s.includes("new")) return "badge-blue";
  if (s.includes("process") && !s.includes("approval")) return "badge-yellow";     // Work in Process
  if (s.includes("sent for approval")) return "badge-pink";
  if (s === "approved") return "badge-emerald";
  if (s.includes("complete")) return "badge-green";
  if (s.includes("cancel") || s.includes("reject")) return "badge-red";
  if (s.includes("hold")) return "badge-gray";
  if (s.includes("document pending")) return "badge-cream";
  if (s.includes("chalan pending")) return "badge-slate";
  return "badge-gray";
};

export default function StatusBadge({ status }) {
  return <span className={`badge ${badgeClass(status)}`} data-testid="status-badge">{status}</span>;
}
